module.exports = __webpack_public_path__ + "static/recommend-cover-4aba5fff250c581781c76554f62bdf70.jpg";